import {
  useApiMutation,
  useApiQuery,
  useLocalizedApiQuery,
} from "../services/react-query";

export const useGetEvents = (params) =>
  useLocalizedApiQuery({
    queryOptions: {
      queryKey: ["events", params],
      enabled: !!params?.workspace,
    },
    fetchOptions: { url: "/events", method: "GET", params },
  });

export const useGetEvent = (id) =>
  useLocalizedApiQuery({
    queryOptions: { queryKey: ["event", { id }], enabled: !!id },
    fetchOptions: { url: `/events/${id}`, method: "GET" },
  });

//public event
export const useGetPublicEvent = (slug) =>
  useLocalizedApiQuery({
    queryOptions: { queryKey: ["event", { slug }], enabled: !!slug },
    fetchOptions: { url: `/public/events/${slug}`, method: "GET" },
  });

export const useCreateEvent = () =>
  useApiMutation({
    mutationOptions: { mutationKey: "useCreateEvent" },
    fetchOptions: { url: "/events", method: "POST" },
    invalidateQueryKeys: [["events"]],
    successMessage: { title: "Event has been created", color: "green" },
  });

export const usePatchEvent = (id) =>
  useApiMutation({
    mutationOptions: { mutationKey: "usePatchEvent" },
    fetchOptions: { url: `/events/${id}`, method: "PATCH" },
    invalidateQueryKeys: [
      ["events"],
      ["event"],
      ["eventDates"],
      ["featureFlags"],
    ],
    successMessage: { title: "Event has been updated", color: "green" },
  });

export const useDeleteEvent = () =>
  useApiMutation({
    mutationOptions: { mutationKey: "useDeleteEvent" },
    fetchOptions: { url: "/events", method: "DELETE" },
    invalidateQueryKeys: [["events"]],
    successMessage: { title: "Event has been deleted", color: "green" },
  });

export const useGetEventLocations = (eventId) => {
  return useLocalizedApiQuery({
    queryOptions: { queryKey: ["eventLocations", eventId] },
    fetchOptions: { url: `/events/${eventId}/locations`, method: "GET" },
  });
};
//public event locations
export const useGetPublicEventLocations = (eventId) => {
  return useLocalizedApiQuery({
    queryOptions: { queryKey: ["eventLocations", eventId], enabled: !!eventId },
    fetchOptions: { url: `/public/events/${eventId}/locations`, method: "GET" },
  });
};

export const useCreateEventLocation = (eventId) => {
  return useApiMutation({
    mutationOptions: { mutationKey: "useCreateEventLocation" },
    fetchOptions: { url: `/events/${eventId}/locations`, method: "POST" },
    invalidateQueryKeys: [["eventLocations", eventId]],
    successMessage: { title: "Location has been created", color: "green" },
  });
};

export const usePatchEventLocation = (eventId, locationId) => {
  return useApiMutation({
    mutationOptions: { mutationKey: "usePatchEventLocation" },
    fetchOptions: {
      url: `/events/${eventId}/locations/${locationId}`,
      method: "PATCH",
    },
    invalidateQueryKeys: [["eventLocations", eventId]],
    successMessage: { title: "Location has been updated", color: "green" },
  });
};

export const useGetLocation = (eventId, locationId) => {
  return useLocalizedApiQuery({
    queryOptions: { queryKey: ["location", { eventId, locationId }] },
    fetchOptions: {
      url: `/events/${eventId}/locations/${locationId}`,
      method: "GET",
    },
  });
};

export const useDeleteEventLocation = (eventId, locationId) => {
  return useApiMutation({
    mutationOptions: { mutationKey: "useDeleteEventLocation" },
    fetchOptions: {
      url: `/events/${eventId}/locations/${locationId}`,
      method: "DELETE",
    },
    invalidateQueryKeys: [["eventLocations", eventId]],
    successMessage: { title: "Location has been deleted", color: "green" },
  });
};

export const useCheckEventSlugAvailability = ({ slug, excludeEventId }) =>
  useApiQuery({
    queryOptions: {
      queryKey: ["eventSlugAvailability", { slug, excludeEventId }],
      enabled: !!slug,
      staleTime: 0,
      retry: false,
    },
    fetchOptions: {
      url: "/events/slug-availability",
      method: "GET",
      params: { slug, ...(excludeEventId ? { excludeEventId } : {}) },
    },
  });

export const useGetEventDates = (eventId) => {
  return useApiQuery({
    queryOptions: { queryKey: ["eventDates", eventId] },
    fetchOptions: { url: `/events/${eventId}/dates`, method: "GET" },
  });
};
export const useGetEventSetupProgress = (eventId) =>
  useApiQuery({
    queryOptions: {
      queryKey: ["eventSetupProgress", eventId],
      enabled: !!eventId,
    },
    fetchOptions: { url: `/events/${eventId}/setup-progress`, method: "GET" },
  });

export const usePatchSetupSkipped = (eventId) =>
  useApiMutation({
    mutationOptions: { mutationKey: "usePatchSetupSkipped" },
    fetchOptions: { url: `/events/${eventId}/customize`, method: "PATCH" },
    invalidateQueryKeys: [["eventSetupProgress"], ["event"]],
  });

//public event dates
export const useGetPublicEventDates = (eventId) => {
  return useApiQuery({
    queryOptions: { queryKey: ["eventDates", eventId], enabled: !!eventId },
    fetchOptions: { url: `/public/events/${eventId}/dates`, method: "GET" },
  });
};
